import type {AxiosInstance} from 'axios';
import type {CommonListArgs, Nullable, PaginatedList} from './types.ts';

export class IGolfApi {
    constructor(private instance: AxiosInstance) {
    }

    public async getClubsBySearch(params: ClubsListArgs) {
        return this.instance.get<PaginatedList<IGolfCourseSearch>>(`/igolf/courses/search`, {params}).then(res => res.data);
    };

    public async getCachedClubs() {
        return this.instance.get<IGolfCourseSearch[]>(`/igolf/courses/`).then(res => res.data);
    };
}

export type ClubsListArgs = {
    search?: string;
} & CommonListArgs;

export type IGolfCourseSearch = {
    id_course: string;
    course_name: string;
    address: string;
    latitude: Nullable<string>;
    longitude: Nullable<string>;
};